import { inflateSync } from 'fflate';


/**
 * Decompresses a Base64-encoded, fflate-compressed payload and returns the parsed JSON object.
 * @param base64String Base64 string containing compressed JSON data.
 * @returns Parsed JSON content obtained after decompression.
 */
export function decompressBase64(base64String: string): any {
  // Decode base64 to Uint8Array
  const binary = atob(base64String);
  const compressed = new Uint8Array([...binary].map(c => c.charCodeAt(0)));
  // Decompress
  const decompressed = inflateSync(compressed);
  // Convert bytes to string
  return JSON.parse(new TextDecoder().decode(decompressed));
}